module.exports = __webpack_public_path__ + "fbdeeaaa294c1846e20b5af6b9a44097.svg";